import React, {
  useEffect,
  useState,
  useCallback,
  useMemo, useRef
} from 'react';
import { Column } from 'devextreme-react/data-grid';
import { Button } from 'devextreme-react/button';
import notify from 'devextreme/ui/notify';
import { TextArea } from 'devextreme-react';
import { LoadIndicator } from 'devextreme-react/load-indicator';
import { formatMessage } from 'devextreme/localization';
import { isOne, trim } from '../../utils/functions';
import DataGridMVP from '../DataGridMVP';
import PopupMVP from '../PopupMVP';
import HeaderButtonMVP from '../HeaderButtonMVP';
import style from './incoming.module.scss';
import PopupErrorMVP from '../PopupErrorMVP';

import columnDataGrid from './columnDataGrid';
import columnDataTranspOrder from './columnDataTranspOrder';
import columnDataProjectNum from './columnDataProjectNum';
import columnDataMX1 from './_consignment/columnDataMX1';
import columnDataMX3 from './_consignment/columnDataMX3';
import columnDataSemiAttrb from '../Shipment/columnDataSemiAttrb';

const Incoming = ({
  incomingReducer: {
    listIncoming,
    okRequest,
    loading,
    loadingData,
    okIncomingAccept,
    error,
    okList
  },
  settingsReducer: { settings },
  tabsReducer: { tabSelect },
  userReducer: {
    permissions,
    id
  },
  getIncoming,
  getIncomingReject,
  getIncomingErrorFalse,
  getIncomingClear,
  plantId,
  modalPostStockOpen,
  modalErrorOpen,
  modalSKZipOpen,
  setInitialStateIncoming,
  showTranspOrder,
  isUseMhOnExpeditor,
  modalPostStockConsignmentOpen,
  isUseM4
}) => {
  /** фильтры из localStorage */
  const localTemp = JSON.parse(localStorage.getItem(`dataGridIncoming${plantId}`));

  const [filterDataGrid, setFilterDataGrid] = useState({
    dateFrom: '',
    dateTo: '',
    filter: localTemp ? localTemp.searchText : ''
  });

  /** Сохранение фильтров для сравнения изменений перед запросом */
  const prevFilterDataGrid = useRef(filterDataGrid);

  const [thisDataGridInstance, setThisDataGridInstance] = useState({});
  const [modalData, setModalData] = useState({ visibleAccept: false, visibleReject: false });
  /** Выбор строк */
  const [dataSource, setDataSource] = useState({
    count: [0, 0, 0],
    listAccept: '',
    listReject: '',
    selectAcceptBoxId: 0,
    selectAcceptItems: [],
    selectAcceptDoc: '',
    selectRejectText: '',
    selectRejectItems: [],
    selectSubmergeItems: [],
    selectItem: true,
    skData: {
      count: 0,
      data: {}
    }
  });
  const [selectItem, setSelectItem] = useState([]);
  /**
   * Переменная для определения текущего рендера списка,
   * где 0 = первый рендер или очистка фильтра
   */
  const isListMounted = useRef(0);

  const [headButtVisibol, setHeadButtVisibol] = useState({ display: 'none' });

  /** Проверка формы */
  const [isValid, setIsValid] = useState(1);
  // Выбранные элементы списка
  const [selected, setSelected] = useState([]);

  /** Сохранение выбранных элементов для передачи в запрос,
   * чтобы не реагировать на каждое изменение selected */
  const prevSelectedRef = useRef(selected);

  /** Стейт обновлены ли поля для изменения ширины */
  const [isFieldsUpdate, setIsFieldUpdate] = useState(false);

  useEffect(() => {
    if (tabSelect === 1) {
      isListMounted.current = 0;
    }
  }, [tabSelect]);

  // Сохранение выбранных элементов текущей вкладки в хранилище
  useEffect(() => {
    if (tabSelect === 1) {
      window.localStorage.setItem('checkedItems', JSON.stringify(selected.map(({ pieceNumId, qcId, actualPieceId, cgId }) => ({ pieceNumId, qcId, actualPieceId, cgId }))));
    } else {
      window.localStorage.removeItem('checkedItems');
    }
  }, [selected, tabSelect]);

  // изменение переменной после получения списка
  useEffect(() => {
    if (okList) {
      isListMounted.current += 1;
    }
  }, [okList]);

  /** Видимость кнопок - Отгрузка, Отмена отгрузки */
  const [visibleBtn, setVisibleBtn] = useState({
    btnIncoming: false,
    btnIncomingCancel: false
  });

  useEffect(() => {
    if (permissions.length) {
      setVisibleBtn({
        btnIncoming: permissions.indexOf('btnIncoming') !== -1,
        btnIncomingCancel: permissions.indexOf('btnIncomingCancel') !== -1
      });
    }
  }, [permissions]);

  useEffect(() => {
    if (okRequest) {
      notify(
        {
          message: formatMessage('pieceStatusChanged'),
          height: 64,
          width: 354,
          position: { at: 'top center', my: 'top center', offset: '0 48' }
        },
        'success',
        2000
      );
      thisDataGridInstance.instance.clearSelection();
      setModalData({ visibleAccept: false, visibleReject: false });
      getIncomingClear();
    }
  }, [okRequest, thisDataGridInstance, getIncomingClear]);

  useEffect(() => {
    prevSelectedRef.current = selected;
  }, [selected]);

  useEffect(() => {
    if (tabSelect !== 1 || id === null) return;

    const prevSelected = prevSelectedRef.current;

    const isFilterActive = Object.values(filterDataGrid).filter(Boolean).length;
    const filtersChanged = prevFilterDataGrid.current !== filterDataGrid;

    // если фильтры изменились
    if (filtersChanged) {
      getIncoming({
        ...filterDataGrid,
        plantId,
        items: prevSelected.map(({ pieceNumId }) => pieceNumId)
      });

      return;
    }

    // если это первый рендер и фильтры пустые
    if (isListMounted.current === 0 && !isFilterActive) {
      getIncoming({
        ...filterDataGrid,
        plantId,
        items: []
      });
    }

    isListMounted.current += 1;
    prevFilterDataGrid.current = filterDataGrid;
  }, [
    tabSelect,
    id,
    filterDataGrid,
    plantId,
    getIncoming,
    thisDataGridInstance.instance
  ]);

  useEffect(() => {
    if (thisDataGridInstance.instance) {
      if (loadingData) {
        thisDataGridInstance.instance.beginCustomLoading('Loading...');
      } else {
        thisDataGridInstance.instance.endCustomLoading();
      }
    }
  }, [loadingData, thisDataGridInstance]);

  /** Событие на закрыть */
  const closeHeaderButtom = useCallback(() => {
    thisDataGridInstance.instance.clearSelection();
    setHeadButtVisibol({ display: 'none' });
    setSelected([]);
  }, [thisDataGridInstance.instance]);

  const dataGridOnSelection = useCallback((selectedRowsData, component, dataSourceDop) => {
    setTimeout(() => {
      if (selectedRowsData.length) {
        const temp = [0, 0, 0];
        let listAccept = '';
        let listReject = '';
        const itemsAccept = [];
        const itemsReject = [];
        const rowsToDeselect = [];
        const selectSubmergeItems = [];
        const skData = {
          count: 0,
          data: {}
        };
        setSelectItem(selectedRowsData);
        selectedRowsData.forEach((item) => {
          skData.count += 1;
          skData.data[item.qcId] = { qcShop: item.qcShopCode, qcDate: item.accountingDate };

          if (item.onHoldFlag) {
            rowsToDeselect.push(item.pieceNumId);
            modalErrorOpen({
              message: `${formatMessage('textModal').textIncomingHoldLeft} ${item.qcId} ${formatMessage('textModal').textIncomingHoldRight}`,
              techInfo: '',
              types: 'info',
              title: formatMessage('textError').warning
            });
          } else {
            // если есть мастер рулон
            // eslint-disable-next-line no-lonely-if
            if (item.mcNumId) {
              rowsToDeselect.push(item.pieceNumId);
              try {
                modalErrorOpen({
                  message: `${formatMessage('textModal').textMPLeft} ${item.mcNum} ${formatMessage('textModal').textMPRight}`,
                  techInfo: '',
                  types: 'info',
                  title: formatMessage('textError').warning
                });
              } catch (e) {
                console.debug('Ошибка при выделение рулона, который в мастер рулоне', e);
              }
            } else if (item.psStatusName === 'В пути') {
              temp[0] += 1;
              listAccept += `${item.cgId} ${item.actualPieceId}; `;
              itemsAccept.push(item.pieceNumId);
              selectSubmergeItems.push(item);
            } else if (item.psStatusName === 'В наличии') {
              temp[1] += 1;
              listReject += `${item.cgId} ${item.actualPieceId}; `;
              itemsReject.push(item.pieceNumId);
            } else if (item.psStatusName === 'Отгружен') {
              temp[2] += 1;
            } else if (item.psStatusName === 'Возвращен') {
              // Снятие выделение с возврата
              rowsToDeselect.push(item.pieceNumId);
              if (item.returnVehicle) {
                modalErrorOpen({
                  message: `${formatMessage('textModal').textIncomingF1Left} ${item.qcId} ${formatMessage('textModal').textIncomingF1Right}`,
                  techInfo: '',
                  types: 'info',
                  title: formatMessage('textError').warning
                });
              } else {
                modalErrorOpen({
                  message: `${formatMessage('textModal').textIncomingF2Left} ${item.qcId} ${formatMessage('textModal').textIncomingF2Right}`,
                  techInfo: '',
                  types: 'info',
                  title: formatMessage('textError').warning
                });
              }
            }
          }
        });
        if (rowsToDeselect.length) {
          component.deselectRows(rowsToDeselect);
        }
        setSelected(selectedRowsData);
        setDataSource({
          ...dataSourceDop,
          listAccept,
          listReject,
          count: temp,
          selectAcceptItems: itemsAccept,
          selectRejectItems: itemsReject,
          selectSubmergeItems,
          skData
        });
        setHeadButtVisibol({ display: 'flex' });
      } else {
        window.localStorage.removeItem('checkedItems');
        setDataSource({
          ...dataSourceDop,
          count: [0, 0, 0],
          skData: {
            count: 0,
            data: {}
          }
        });
        setHeadButtVisibol({ display: 'none' });
        setSelected([]);
      }
    }, 0);
  }, [modalErrorOpen]);

  /** Поисковая строка */
  const dataGridOnOptionChanged = useCallback(({ value, name }) => {
    if (name === 'searchPanel') {
      if (!value) {
        isListMounted.current = 0;
      }
      setFilterDataGrid({ ...filterDataGrid, filter: value });
    }
  }, [filterDataGrid]);
  /** Работа с модальками */
  const onClickButtonAccept = useCallback(() => {
    // getIncomingListStocks({ plantId });
    if (
      isOne(
        selectItem.filter((item) => dataSource.selectAcceptItems.indexOf(item.pieceNumId) >= 0),
        'plantId',
        Number(plantId)
      ) || plantId > 10000
    ) {
      if (isUseMhOnExpeditor) {
        modalPostStockConsignmentOpen({
          plantId,
          selectSubmergeItems: dataSource.selectSubmergeItems,
          selectAcceptItems: dataSource.selectAcceptItems
        });
      } else {
        modalPostStockOpen({
          listAccept: dataSource.listAccept,
          itemsAccept: dataSource.selectAcceptItems,
          plantId
        });
      }
    } else {
      modalErrorOpen({
        message: formatMessage('textError').differentWarehousesSelected,
        techInfo: '',
        types: 'info',
        title: formatMessage('textError').warning
      });
    }

    setDataSource({
      ...dataSource,
      selectItem: true,
      selectAcceptDoc: '',
      selectRejectText: ''
    });
  }, [
    dataSource,
    modalErrorOpen,
    modalPostStockOpen,
    plantId,
    selectItem,
    isUseMhOnExpeditor,
    modalPostStockConsignmentOpen
  ]);
  const onClickButtonReject = useCallback(() => {
    if (
      isOne(
        selectItem.filter((item) => dataSource.selectAcceptItems.indexOf(item.pieceNumId) >= 0),
        'plantId',
        Number(plantId)
      ) || plantId > 10000
    ) {
      setModalData({
        ...modalData,
        visibleReject: true
      });
    } else {
      modalErrorOpen({
        message: formatMessage('textError').differentWarehousesSelected,
        techInfo: '',
        types: 'info',
        title: formatMessage('textError').warning
      });
    }
    setIsValid(1);
    setDataSource({
      ...dataSource,
      selectAcceptDoc: '',
      selectRejectText: ''
    });
  }, [
    dataSource,
    modalData,
    modalErrorOpen,
    plantId,
    selectItem
  ]);
  const modalOnHiding = useCallback(() => {
    setModalData({ visibleAccept: false, visibleReject: false });
  }, []);

  /** Отправка на отказ */
  const sendReject = useCallback((dataSourceTemp, thisDataGridInstanceT) => {
    if (dataSourceTemp.selectRejectText !== '' && dataSourceTemp.selectRejectText !== null) {
      getIncomingReject({
        items: dataSourceTemp.selectRejectItems,
        note: dataSourceTemp.selectRejectText,
        plantId
      });
    } else {
      setIsValid(0);
    }
    // eslint-disable-next-line
  }, [plantId]);

  // Групповое скачивание СК
  const onClickButtonSK = useCallback(() => {
    modalSKZipOpen({
      data: dataSource.skData.data,
      plantId
    });
  }, [
    dataSource.skData.data,
    modalSKZipOpen,
    plantId
  ]);

  // Обновление данных
  const onClickUpdate = useCallback(() => {
    const isFilterActive = Object.values(filterDataGrid).filter(Boolean).length;
    if (isFilterActive) {
      getIncoming({
        ...filterDataGrid,
        plantId,
        items: selected.map(({ pieceNumId }) => pieceNumId)
      });
    } else {
      getIncoming({
        ...filterDataGrid,
        plantId,
        items: []
      });
    }
  }, [filterDataGrid, getIncoming, plantId, selected]);

  // Обновление данных после приемки
  useEffect(() => {
    if (okIncomingAccept) {
      onClickUpdate();
      setInitialStateIncoming();
    }
  }, [onClickUpdate, okIncomingAccept, setInitialStateIncoming]);

  /** Изменение ширины полей TODO придумать что-нибудь лаконичнее */
  useEffect(() => {
    if (listIncoming.length && localTemp && !isFieldsUpdate) {
      let fieldModify = false;
      let dataFieldsName = ['qcId', 'documentId', 'mh3'];
      dataFieldsName.forEach((fieldName) => {
        let controlField = {
          name: fieldName,
          maxLength: 0,
          index: 0
        };
        if (!localTemp.columns.filter((item) => item.dataField === fieldName)[0]?.width) {
          localTemp.columns.forEach((item, index) => item.dataField === fieldName ? controlField.index = index : null);
          listIncoming.forEach((item) => item[fieldName]?.length * 12 > controlField.maxLength ? controlField.maxLength = item[fieldName].length * 12 : null);
          if (controlField.maxLength !== 0) {
            localTemp.columns[controlField.index].width = controlField.maxLength;
            fieldModify = true;
          }
        }
      });
      if (fieldModify) {
        localStorage.setItem(`dataGridIncoming${plantId}`, JSON.stringify(localTemp));
        setIsFieldUpdate(true);
        onClickUpdate();
      }
    }
  }, [localTemp, listIncoming, isFieldsUpdate, plantId, onClickUpdate]);

  const renderColumnTranspOrder = useMemo(() => (
    columnDataTranspOrder.map(
      (item) => (
        <Column dataField={item.dataField}
                caption={formatMessage('textTable')[item.dataField]}
                visible={!item.notVisible}
                allowSearch={false}
                allowFiltering
                cellRender={item.cellRender}
                key={item.dataField}
                dataType={item.dataType}
                cssClass={item.cssClass}
        />
      )
    )
  ), []);

  const renderColumnProjectNum = useMemo(() => (
    columnDataProjectNum.map(
      (item) => (
        <Column dataField={item.dataField}
                caption={formatMessage('textTable')[item.dataField]}
                visible={!item.notVisible}
                allowSearch={false}
                allowFiltering
                cellRender={item.cellRender}
                key={item.dataField}
                dataType={item.dataType}
                cssClass={item.cssClass}
                width={item.width ? item.width : undefined}
        />
      )
    )
  ), []);

  const renderColumnMX1M4 = useMemo(() => (
    columnDataMX1.filter((item) => item.dataField !== 'mh1DocStatusDescr'
      && item.dataField !== 'departureDate')
      .map(
        (item) => (
          <Column dataField={item.dataField}
                caption={isUseM4 ? formatMessage('textTable').MX1M4[item.dataField] : formatMessage('textTable').consignment[item.dataField]}
                visible={!item.notVisible}
                allowSearch={false}
                allowFiltering
                cellRender={item.cellRender}
                key={item.dataField}
                dataType={item.dataType}
                cssClass={item.cssClass}
        />
        )
      )
  ), [isUseM4]);

  const renderColumnMX3 = useMemo(() => (
    columnDataMX3.map(
      (item) => (
        <Column dataField={item.dataField}
                caption={formatMessage('textTable').consignment[item.dataField]}
                visible={!item.notVisible}
                allowSearch={false}
                allowFiltering
                cellRender={item.cellRender}
                key={item.dataField}
                dataType={item.dataType}
                cssClass={item.cssClass}
        />
      )
    )
  ), []);

  const renderColumnSemiAttrb = useMemo(() => (
    columnDataSemiAttrb.map(
      (item) => (
        <Column dataField={item.dataField}
                caption={formatMessage('textTable')[item.dataField]}
                visible={!item.notVisible}
                allowSearch={false}
                allowFiltering
                cellRender={item.cellRender}
                key={item.dataField}
                dataType={item.dataType}
                cssClass={item.cssClass}
                width={item.width ? item.width : undefined}
        />
      )
    )
  ), []);

  const renderDataGrid = useMemo(() => (
    <DataGridMVP dataSource={listIncoming}
                 onSelectionChanged={({ selectedRowsData, component }) => dataGridOnSelection(
                   selectedRowsData,
                   component,
                   dataSource
                 )}
                 dataGridOnOptionChanged={dataGridOnOptionChanged}
                 setDataGridInstance={setThisDataGridInstance}
                 filterDataGrid={filterDataGrid}
                 setFilterDataGrid={setFilterDataGrid}
                 className="incoming"
                 setStateStoringName={`dataGridIncoming${plantId}`}
                 tText={formatMessage('textPeriodAcceptance')}
                 loadingData={loadingData}
                 visibleButtonUpdate
                 onClickUpdate={onClickUpdate}
                 shrinkToolbar={headButtVisibol.display !== 'none'}
    >
      { columnDataGrid.map(
        (item) => {
          if (item.dataField === 'widthFact' && !settings.useMC) {
            return null;
          }

          return (
            <Column dataField={item.dataField}
                    caption={formatMessage('textTable')[item.dataField]}
                    visible={!item.notVisible}
                    allowSearch={false}
                    allowFiltering
                    cellRender={item.cellRender}
                    key={item.dataField}
                    dataType={item.dataType}
                    cssClass={item.cssClass}
                    width={item.width ? item.width : undefined}
            />
          );
        }
      ) }
      { showTranspOrder ? renderColumnTranspOrder : null }
      { settings.stockType ? renderColumnProjectNum : null }
      {isUseMhOnExpeditor ? renderColumnMX1M4 : null}
      {isUseMhOnExpeditor ? renderColumnMX3 : null}
      { settings.showSemiAttrb ? renderColumnSemiAttrb : null }
    </DataGridMVP>
  ), [
    dataGridOnOptionChanged,
    dataGridOnSelection,
    dataSource,
    filterDataGrid,
    showTranspOrder,
    listIncoming,
    loadingData,
    onClickUpdate,
    plantId,
    renderColumnTranspOrder,
    settings,
    renderColumnProjectNum,
    isUseMhOnExpeditor,
    renderColumnMX1M4,
    renderColumnMX3,
    headButtVisibol.display,
    renderColumnSemiAttrb
  ]);

  return (
    <>
      <HeaderButtonMVP headButtVisibol={headButtVisibol}>
        <Button icon={'close'} stylingMode={'text'} onClick={closeHeaderButtom} />
        <span className={'span-first'}>{`${formatMessage('textDataGrid').selectQU}:`}</span>
        { (dataSource.count[0])
          ? (
            <>
              <span>{`“В пути” - ${dataSource.count[0]}`}</span>
              {(visibleBtn.btnIncoming)
                ? (
                  <Button text={formatMessage('textButton').placeStock}
                          type="default"
                          stylingMode="contained"
                          onClick={onClickButtonAccept}
                  />
                ) : ''}
            </>
          )
          : <div />}
        { (dataSource.count[1])
          ? (
            <>
              <span>{`“В наличии” - ${dataSource.count[1]}`}</span>
              {(visibleBtn.btnIncomingCancel)
                ? (
                  <Button text={formatMessage('textButton').refuseAcceptance}
                          type="default"
                          stylingMode="contained"
                          onClick={onClickButtonReject}
                  />
                ) : ''}
            </>
          )
          : <div />}
        { (dataSource.count[2])
          ? (
            <>
              <span>{`“Отгружен” - ${dataSource.count[2]}`}</span>
            </>
          )
          : <div />}
        {(dataSource.skData.count
          ? (
            <>
              <Button text={formatMessage('textButton').downloadQc}
                      type="default"
                      stylingMode="contained"
                      onClick={onClickButtonSK}
              />
            </>
          )
          : <div />)}
      </HeaderButtonMVP>
      { renderDataGrid }
      {/* Модальные окна на ПРИЕМ и ОТКАЗ */}
      <PopupMVP visible={modalData.visibleReject}
                onHiding={modalOnHiding}
                title={formatMessage('textModal').refusalToAccept}
      >
        <div className="formData">
          <div className={style.containing}>
            <p>{`№ : ${dataSource.listReject !== '' ? trim(trim(dataSource.listReject, ' '), ';') : ''}`}</p>
          </div>
          <div className="optionsData">
            <span className={(isValid) ? '' : style.errorText}>{formatMessage('textData').rejectionReason}</span>
            <TextArea height={80}
                      value={dataSource.selectRejectText}
                      onValueChanged={({ value }) => setDataSource({
                        ...dataSource,
                        selectRejectText: value
                      })}
                      stylingMode="outlined"
                      isValid={!!isValid}
                      onFocusIn={() => setIsValid(1)}
                      validationError={{ message: formatMessage('textError').enterRejectionReason }}
            />
          </div>
          <div className="formButton">
            <Button text={formatMessage('textButton').cancel}
                    type="default"
                    stylingMode="text"
                    onClick={modalOnHiding}
            />
            <Button type="default"
                    stylingMode="contained"
                    width={260}
                    disabled={loading}
                    onClick={() => sendReject(dataSource, thisDataGridInstance)}
            >
              <LoadIndicator className="indicator" visible={loading} />
              <span>{formatMessage('textButton').refuseAcceptance}</span>
            </Button>
          </div>
        </div>
      </PopupMVP>
      <PopupErrorMVP visible={!!error}
                     message={error.message}
                     techInfo={error.techInfo}
                     onHiding={getIncomingErrorFalse}
                     width="600"
                     types="error"
      />
    </>
  );
};

export default Incoming;
